import { ColDef } from "../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../records/grids/columns/columnDefinitionService";
import { simpleLookupConfig } from "../../records/lookup/config/simpleLookupConfig";
import fieldHelpers from "../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName as mealLogLookupManagementServiceProviderName } from "./lookups";

export const vsObjectName = "mealLogReason";

export const mealLogReasonConfig = simpleLookupConfig(
  mealLogLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Reason",
    url: "/api/machines/meallog/MealLogReason",
    namePlural: "Reasons",
    defaultSort: "Order",
    additionalColumns: [
      ColumnDefinitionServiceName,
      (columnDefinitionService: ColumnDefinitionService): ColDef[] => {
        return [
          columnDefinitionService.getBooleanColDef({
            field: "NotesRequired",
            header: "Notes Required",
          }),
          columnDefinitionService.getNumberColDef({
            field: "Order",
          }),
        ];
      },
    ],
    additionalFields: [
      (): AngularFormly.IFieldConfigurationObject[] => {
        return [
          fieldHelpers.simpleBoolField({
            key: "NotesRequired",
            name: "NotesRequired",
            label: "Notes Required?",
          }),
          fieldHelpers.simpleNumberField({
            key: "Order",
            name: "Order",
            label: "Order",
            step: 1,
          }),
        ];
      },
    ],
  }
);
